import "./IconFeedback.scss";
import { ReactComponent as FeedbackIcon } from "./svg/icon_feedback.svg";

export const IconFeedback = () => {
  return (
    <span className="IconFeedback">
      <FeedbackIcon />
    </span>
  );
};
